export const EAPTEKA_MOCK_COLLECTIONS = {
  cartGet: 'cartGet',
  recommendationProductsGet: 'recommendationProductsGet'
};

const API_URLS_MAP: Record<string, string> = {
  'release.eapteka.ru':
    'https://apirelease.eapteka.ru/api/v3/web',
  'eapteka.ru': 'https://api.eapteka.ru/api/v3/web',
  'www.eapteka.ru': 'https://api.eapteka.ru/api/v3/web'
};

export const baseApiUrl: string = (() => {
  if (
    typeof location !== 'undefined' &&
    location.hostname in API_URLS_MAP
  ) {
    return API_URLS_MAP[location.hostname];
  }

  return typeof API_URL !== 'undefined'
    ? API_URL
    : '/api/v3/web';
})();
